module.exports = __webpack_public_path__ + "static/media/csr_2_makanan_berbuka.8e118c28.jpg";